import { render, staticRenderFns } from "./ProductCardItem.vue?vue&type=template&id=5fb3149b&scoped=true"
import script from "./ProductCardItem.vue?vue&type=script&lang=js"
export * from "./ProductCardItem.vue?vue&type=script&lang=js"
import style0 from "./ProductCardItem.vue?vue&type=style&index=0&id=5fb3149b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb3149b",
  null
  
)

export default component.exports